import PropTypes from "prop-types";
import Button from "@/components/common/Button";
import ExpenseItem from "@/pages/finance_manager/components/Expense_Item";
import { PlusOutlined } from "@/config/antd";

const ExpenseItemsList = ({
  title = "Items to be purchased",
  subtitle = "Add as many items as possible to the expense",
  items,
  onItemChange,
  onAddItem,
  className = "",
}) => {
  const calculateGrandTotal = () => {
    return items.reduce(
      (sum, item) => sum + Number(item.quantity) * Number(item.price || 0),
      0
    );
  };

  return (
    <div className={`w-full ${className}`}>
      <h2 className="text-bold text-lighterGrey">{title}</h2>
      <p className="mt-2 mb-6 text-regular text-lighterGrey">{subtitle}</p>

      <div className="space-y-4">
        {items.map((item) => (
          <ExpenseItem
            key={item.id}
            item={item}
            onChange={(updatedItem) => onItemChange(updatedItem)}
          />
        ))}
      </div>

      <div className="flex items-center justify-between mt-6 mb-4">
        <span className="text-bold text-lightGrey">TOTAL (₦)</span>
        <span className="text-bold text-lightGrey">
          {calculateGrandTotal().toLocaleString()}
        </span>
      </div>

      <Button
        text="ADD MORE ITEMS"
        onClick={onAddItem}
        icon={<PlusOutlined />}
        iconPosition="left"
        className="w-full h-[36px] border border-primary !text-primary !bg-white font-normal hover:!bg-primary hover:!text-white"
      />
    </div>
  );
};

ExpenseItemsList.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      item: PropTypes.string,
      quantity: PropTypes.number,
      price: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    })
  ),
  onItemChange: PropTypes.func,
  onAddItem: PropTypes.func,
  className: PropTypes.string,
};

export default ExpenseItemsList;
